__turbopack_context__.v({
  "wrapper": "Shared-module-scss-module__-I7n1a__wrapper",
});
